export default "__VITE_ASSET__pJK9fPl1__"